import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import PropsChecker from '@core-front/props-checker';
const NumberCore = (props) => {
    return (React.createElement(PropsChecker, { componentName: "Number", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange", isComponentDisabled: props.disabled || !!(props.input && props.input.disabled) },
        React.createElement(AnalyticsTrigger, { trigger: [
                {
                    callback: 'onIncrease',
                    id: `Number - Increase - ${props.id}`,
                    elementId: props.id,
                    elementType: 'number',
                    interactionType: 'increase',
                },
                {
                    callback: 'onDecrease',
                    id: `Number - Decrease - ${props.id}`,
                    elementId: props.id,
                    elementType: 'number',
                    interactionType: 'decrease',
                },
                {
                    callback: 'onManualChange',
                    id: `Number - Filled - ${props.id}`,
                    elementId: props.id,
                    elementType: 'number',
                    interactionType: 'fill',
                },
            ] },
            React.createElement(NumberCoreInner, Object.assign({}, props)))));
};
const NumberCoreInner = (props) => {
    const { max = 999, min = 0, step = 1, variant = 'secondary', defaultValue = 0, value, isInvalid, disabled, size, align, hideLabel, className, id, label, decreaseButtonText, increaseButtonText, input, name, helper, required, } = props;
    const { Button, FormHelper } = props.components;
    const [innerValue, setInnerValue] = React.useState(defaultValue);
    const currentValue = isValueControlled(value) ? value : innerValue;
    const isDisabled = disabled || !!(input && input.disabled);
    const isAriaInvalid = isInvalid || (!!helper && helper.type === 'error');
    function isValueControlled(outerValue = value) {
        return !!props.onChange && typeof outerValue !== 'undefined';
    }
    function onDecrease(event) {
        event.preventDefault();
        setValue(currentValue - step, 'decrease');
    }
    function onIncrease(event) {
        event.preventDefault();
        setValue(currentValue + step, 'increase');
    }
    function onChange(event) {
        const newValue = Number(event.currentTarget.value);
        if (props.onManualChange) {
            props.onManualChange();
        }
        setValue(newValue, 'manual');
    }
    function setValue(newValue, change) {
        let actualNewValue = newValue;
        // if the value is not an integer,
        if (!(newValue % 1 === 0)) {
            // if step is defined and not an integer (= floating)
            if (step && !Number.isInteger(step)) {
                if (change !== 'manual') {
                    actualNewValue = parseFloat(newValue.toFixed(10));
                }
            }
            else {
                // set the value to the minimum value
                actualNewValue = min;
            }
        }
        // if the value is smaller than minimum value,
        // reset the value to the minimum value
        if (newValue < min) {
            actualNewValue = min;
        }
        // if the value is greater than maximum value,
        // reset the value to the maximum value
        if (newValue > max) {
            actualNewValue = max;
        }
        if (!isValueControlled()) {
            setInnerValue(actualNewValue);
        }
        if (props.onChange) {
            props.onChange(actualNewValue);
        }
        if (props.onDecrease && change === 'decrease') {
            props.onDecrease(actualNewValue);
        }
        if (props.onIncrease && change === 'increase') {
            props.onIncrease(actualNewValue);
        }
    }
    function BEM() {
        const classArray = ['number'];
        if (disabled) {
            classArray.push('is-disabled');
        }
        if (isInvalid) {
            classArray.push('is-invalid');
        }
        if (hideLabel) {
            classArray.push('number--hide-label');
        }
        if (size) {
            classArray.push('number--' + size);
        }
        if (align) {
            classArray.push('number--align-' + align);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    return (React.createElement("div", { className: BEM() },
        React.createElement("label", { htmlFor: id, className: "number__label" }, label),
        React.createElement("div", { className: "number__inner" },
            React.createElement(Button, { disabled: isDisabled || currentValue === min, onClick: onDecrease, variant: variant, icon: "#minus", size: "small", text: decreaseButtonText }),
            React.createElement("input", Object.assign({}, input, { className: "number__input", type: "number", id: id, name: name, value: currentValue, disabled: isDisabled, onChange: onChange, "aria-invalid": isAriaInvalid, "aria-describedby": helper ? helper.id || `${id}-helper` : undefined, "aria-required": required })),
            React.createElement(Button, { disabled: isDisabled || currentValue === max, onClick: onIncrease, variant: variant, icon: "#plus", size: "small", text: increaseButtonText })),
        helper && React.createElement(FormHelper, Object.assign({}, helper, { className: "number__form-helper", id: helper.id || `${id}-helper` }))));
};
export { NumberCore as default };
